type Args = {
	accountId: number;
	audioRetentionDays: number;
	beneficiaryRetentionMonths: number;
};

class UpdateRetentionSettings {
	readonly accountId: number;
	readonly audioRetentionDays: number;
	readonly beneficiaryRetentionMonths: number;

	constructor(args: Args) {
		this.accountId = args.accountId;
		this.audioRetentionDays = args.audioRetentionDays;
		this.beneficiaryRetentionMonths = args.beneficiaryRetentionMonths;

		Object.freeze(this);
	}

	// `accountId` is the route identifier: it is never echoed in the request body.
	toJSON(): Record<string, unknown> {
		return {
			audioRetentionDays: this.audioRetentionDays,
			beneficiaryRetentionMonths: this.beneficiaryRetentionMonths,
		};
	}
}

export default UpdateRetentionSettings;
